import { Component, OnInit, OnDestroy,Input, OnChanges } from '@angular/core';
import { CovidService } from 'src/app/covid.service';
import { LazyloadService } from 'src/app/lazyload.service';

declare global {
  interface Window { _altmetric_embed_init: any; }
}
window._altmetric_embed_init = window._altmetric_embed_init || {};
@Component({
  selector: 'app-popular',
  templateUrl: './popular.component.html',
  styleUrls: ['./popular.component.less']
})
export class PopularComponent implements OnInit, OnDestroy, OnChanges {
  @Input() active: number;
  data = null;
  articles = null;
  lazy = null;
  embedInit = null;
  firstOpen = true;
  constructor(private service: CovidService, private lazyload: LazyloadService) { }

  ngOnInit(): void {
   this.init();
   setTimeout(() => {
    this.lazy = this.lazyload
    .loadScript('https://d1bxh8uas1mnw7.cloudfront.net/assets/altmetric_badges-eb187a407f01c9f3bbcda1dddf27884f.js')
   .subscribe(() => {
     window._altmetric_embed_init();
   });
   }, 500);
  }

  ngOnChanges(changes: any) {
    if (changes.active.currentValue && changes.active.currentValue === 1 && this.firstOpen) {
      window._altmetric_embed_init();
      this.firstOpen = false;
    }
  }

  init() {
    this.data = this.service.getPopularArticles().subscribe(response =>{
      this.formatter(response);
    });
  }
  formatter(response) {
    const { citations } = response;
    this.articles = this.getArticles(citations);
  }

  getArticles(citations) {
    return citations.map(this.service.formattArticles);
  }

  ngOnDestroy() {
    this.lazy.unsubscribe();
    this.articles.unsubscribe();
  }

}
